import React from 'react'
import './nav_home_out.css'

import {AiOutlineHome} from 'react-icons/ai'
import {MdMiscellaneousServices} from 'react-icons/md'
import { useState } from 'react'
import {BiLogOut} from 'react-icons/bi'

const Nav = () => {
  const [activeNav,setActiveNav]=useState('/adminactions')
  function logout(){
    setActiveNav('/login')
    localStorage.setItem('auth',false)
  }
  return (
    <nav>
      <a href='/'onClick={()=>setActiveNav('#')} className={activeNav==='#'?'active':''}><AiOutlineHome/></a>
      <a href='/adminactions'onClick={()=>setActiveNav('/adminactions')} className={activeNav==='/adminactions'?'active':''}><MdMiscellaneousServices/></a>
      <a href='/admin'onClick={logout} className={activeNav==='/login'?'active':''}><BiLogOut/></a>
    </nav>
  )
}

export default Nav